<ng-container
  *ngIf="
    platformService?.platformType !== platformService?.platformEnum?.mobile
  "
>
  <div data-cy="product-card-label-container" class="product-card-labels">
    <div class="space"></div>
    <p data-cy="brand-label-text" class="brand">
      {{ 'i18n.scoop.brand' | translate }}
    </p>
    <p data-cy="description-label-text" class="description">
      {{ 'i18n.scoop.productDescription' | translate }}
    </p>
    <p data-cy="product-number-label-text" class="product-number">
      {{ 'i18n.scoop.productNumber' | translate }}
    </p>
    <p data-cy="pack-size-label-text" class="pack-size">
      {{ 'i18n.scoop.packSize' | translate }}
    </p>
    <p data-cy="ind-label-text" class="customer-type">IND</p>
    <p data-cy="premier-label-text" class="customer-type">Premier</p>
    <p data-cy="vizient-label-text" class="customer-type">Vizient</p>
    <p data-cy="avendra-label-text" class="customer-type">Avendra</p>
  </div>

  <ion-card
    [attr.data-cy]="'sneak-peek-product-card-' + i"
    class="product-card"
    *ngFor="
      let sneakPeekProduct of sneakPeekProducts;
      trackBy: trackByIndex;
      let i = index
    "
  >
    <div
      [attr.data-cy]="'thumbnail-container-' + i"
      class="thumbnail-container"
      (click)="onProductClick(sneakPeekProduct?.productNumber, i + 1)"
    >
      <img
        [attr.data-cy]="'thumbnail-image-' + i"
        *ngIf="
          (panAppState.online$ | async) && !!sneakPeekProduct?.imageThumbnail
        "
        src="{{ sneakPeekProduct?.imageThumbnail }}"
        class="thumbnail"
        (click)="onProductImageClick(sneakPeekProduct, i + 1)"
      />
      <ion-icon
        [attr.data-cy]="'thumbnail-no-image-' + i"
        *ngIf="
          (panAppState.online$ | async) === false ||
          !sneakPeekProduct?.imageThumbnail
        "
        name="restaurant"
        class="thumbnail no-image"
      >
      </ion-icon>
    </div>
    <p [attr.data-cy]="'brand-name-text-' + i" class="brand line-clamp">
      {{ sneakPeekProduct?.summary?.brand || ' ' | acronymTitleCase }}
    </p>
    <p
      [attr.data-cy]="'description-text-' + i"
      class="description link-text line-clamp"
      (click)="onProductClick(sneakPeekProduct?.productNumber, i + 1)"
    >
      {{ sneakPeekProduct?.summary?.productDescTxtl || ' ' | acronymTitleCase }}
    </p>
    <p [attr.data-cy]="'product-number-text-' + i" class="product-number">
      {{ sneakPeekProduct?.productNumber }}
    </p>
    <p [attr.data-cy]="'pack-size-text-' + i" class="pack-size">
      {{ sneakPeekProduct?.summary?.salesPackSize || ' ' }}
    </p>
    <div
      [attr.data-cy]="'customer-type-icon-' + i + '-' + j"
      *ngFor="
        let isFilled of [
          sneakPeekProduct?.isInd,
          sneakPeekProduct?.isPremier,
          sneakPeekProduct?.isVizient,
          sneakPeekProduct?.isAvendra,
        ];
        let j = index
      "
      class="checkmark-container"
    >
      <ion-icon
        [attr.data-cy]="'customer-type-filled-icon-' + i + '-' + j"
        *ngIf="isFilled"
        name="checkmark-circle"
        class="filled"
      >
      </ion-icon>
      <ion-icon
        [attr.data-cy]="'customer-type-empty-icon-' + i + '-' + j"
        *ngIf="!isFilled"
        name="checkmark-circle"
        class="empty"
      >
      </ion-icon>
    </div>
  </ion-card>
</ng-container>

<ng-container
  *ngIf="
    platformService?.platformType === platformService?.platformEnum?.mobile
  "
>
  <ion-card
    [attr.data-cy]="'sneak-peek-product-card-mobile-' + i"
    class="product-card mobile"
    *ngFor="
      let sneakPeekProduct of sneakPeekProducts;
      trackBy: trackByIndex;
      let i = index
    "
  >
    <div
      [attr.data-cy]="'product-content-container-' + i"
      class="product-content-container"
    >
      <div
        [attr.data-cy]="'thumbnail-container-mobile-' + i"
        class="thumbnail-container"
        (click)="onProductImageClick(sneakPeekProduct, i + 1)"
      >
        <img
          [attr.data-cy]="'thumbnail-image-mobile-' + i"
          *ngIf="
            (panAppState.online$ | async) && !!sneakPeekProduct?.imageThumbnail
          "
          src="{{ sneakPeekProduct?.imageThumbnail }}"
          class="thumbnail"
        />
        <ion-icon
          [attr.data-cy]="'thumbnail-no-image-mobile-' + i"
          *ngIf="
            (panAppState.online$ | async) === false ||
            !sneakPeekProduct?.imageThumbnail
          "
          name="restaurant"
          class="thumbnail no-image"
        >
        </ion-icon>
      </div>
      <div [attr.data-cy]="'details-container-' + i" class="details">
        <p
          [attr.data-cy]="'brand-name-text-mobile-' + i"
          class="line-clamp one-line"
        >
          {{ sneakPeekProduct?.summary?.brand || ' ' | acronymTitleCase }}
        </p>
        <p
          [attr.data-cy]="'description-text-mobile-' + i"
          class="link-text line-clamp"
          (click)="onProductClick(sneakPeekProduct?.productNumber, i + 1)"
        >
          {{
            sneakPeekProduct?.summary?.productDescTxtl || ' ' | acronymTitleCase
          }}
        </p>
        <div
          [attr.data-cy]="'product-number-pack-size-container-' + i"
          class="product-number-pack-size"
        >
          <p [attr.data-cy]="'product-number-text-mobile-' + i">
            #{{ sneakPeekProduct?.productNumber }}
          </p>
          <ng-container
            *ngIf="sneakPeekProduct?.summary?.salesPackSize as packSize"
          >
            <div class="separator"></div>
            <p [attr.data-cy]="'pack-size-text-mobile-' + i">
              {{ packSize }}
            </p>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      [attr.data-cy]="'customer-type-container-' + i"
      class="customer-type-container"
    >
      <div
        [attr.data-cy]="'customer-type-text-icon-container' + i + '-' + j"
        *ngFor="
          let customerType of [
            ['IND', sneakPeekProduct?.isInd],
            ['Premier', sneakPeekProduct?.isPremier],
            ['Vizient', sneakPeekProduct?.isVizient],
            ['Avendra', sneakPeekProduct?.isAvendra],
          ];
          let j = index
        "
        class="checkmark-container mobile"
      >
        <p [attr.data-cy]="'customer-type-text-' + i + '-' + j">
          {{ customerType[0] }}
        </p>
        <ion-icon
          [attr.data-cy]="'customer-type-filled-icon-mobile' + i + '-' + j"
          *ngIf="customerType[1]"
          name="checkmark-circle"
          class="filled"
        >
        </ion-icon>
        <ion-icon
          [attr.data-cy]="'customer-type-empty-icon-mobile' + i + '-' + j"
          *ngIf="!customerType[1]"
          name="checkmark-circle"
          class="empty"
        >
        </ion-icon>
      </div>
    </div>
  </ion-card>
</ng-container>
